import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SnackbarService } from '../../snackbar/snackbar.service';
import { LoadingInterceptor } from '../loading.interceptor';

export const interceptorProviders =
    [
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SnackbarService, multi: true }
    ];